
export function isExternal (path) {
    return /^(https?:|mailto:|tel:)/.test(path)
  }
  
  export function validURL (url) {
    const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return reg.test(url)
  }
  
  export function validLowerCase (str) {
    const reg = /^[a-z]+$/
    return reg.test(str)
  }
  
  export function validUpperCase (str) {
    const reg = /^[A-Z]+$/
    return reg.test(str)
  }
  
  export function validAlphabets (str) {
    const reg = /^[A-Za-z]+$/
    return reg.test(str)
  }
  
  export function isString (str) {
    if (typeof str === 'string' || str instanceof String) {
      return true
    }
    return false
  }
  
  export function isArray (arg) {
    if (typeof Array.isArray === 'undefined') {
      return Object.prototype.toString.call(arg) === '[object Array]'
    }
    return Array.isArray(arg)
  }

export function formatNumberWithCommas(number) {
  return new Intl.NumberFormat().format(number);
}
